module.exports = __webpack_public_path__ + "static/media/HT.317ce41a.svg";